import { FeatureFlagConfig } from '../components/Feature';

export type EnvironmentTypes = 'develop' | 'staging' | 'production';

export interface LaunchDarklyEnvConfig {
  // launch darkly client IDs
  develop: string;
  staging: string;
  production: string;
}

export interface DataDogRumConfig {
  applicationId: string;
  clientToken: string;
}

export interface DataDogEnvConfig {
  develop: DataDogRumConfig;
  staging: DataDogRumConfig;
  production: DataDogRumConfig;
}
export interface ConfigurationStateInterface {
  baseUrl: string; // base url of the main API
  tpCoreApiUrl: string;
  compSearchApiUrl: string; // Comp Search API
  docApiUrl: string; // base url of platform docuemnt API
  tpReportGeneratorApiUrl: string; // base url of TP Report Generator API
  authUrl: string; // base url of auth stack
  loginStackRelativeUrl: string; // realtive path for generic login page
  complianceCentralApiUrl: string; // base url of Compliance Central API
  planningApiUrl: string; // base url of planning lambda
  planningWebSocketUrl: string; // base url of planning web socket
  principleUrl: string; // base url of principle api
  adminUrl: string; // base url of admin stack
  proxyUrl: string; // base url of platform proxy
  tpUIReports: string; // base url of report transfer pricing ui app
  exacteraDomainUrl: string; // base url of exactera domain
  xbsEnvironment: EnvironmentTypes;
  xbsEnvironmentShort: string;
  buildTime: string;
  clientAppId: string;
  googleAnalyticsTrackId: Record<EnvironmentTypes, string>;
  featureFlags: FeatureFlagConfig;
  launchDarklyEnv: LaunchDarklyEnvConfig;
  dataDogRumConfig: DataDogEnvConfig;
}

declare global {
  interface Window {
    configuration: ConfigurationStateInterface;
  }
}

export const getAppConfig = (): ConfigurationStateInterface => window.configuration || {};

// The self-hosted LanguageTool service (xbs-languagetool-stack) follows the
// org DNS convention for ECS Fargate stacks, so the per-env URL is derived
// from the environment rather than shipped as another configuration key.
export const getLanguageToolUrl = (): string => {
  const short = getAppConfig().xbsEnvironmentShort;
  if (!short) {
    // Fall back to dev rather than emit a malformed host, but surface it: a
    // missing env short means config didn't load, and silently checking dev
    // from another env would be a confusing failure mode to debug.
    console.warn('xbsEnvironmentShort is not set; defaulting LanguageTool URL to dev.');
  }

  // `|| 'dev'` (not `??`) so an empty-string short — which also trips the warn
  // above — falls back rather than producing a malformed `languagetool.xbs.com`.
  return `https://languagetool.${short || 'dev'}xbs.com/v2/check`;
};
